// Assuming UserService is available and imported
import { ResolveFn } from '@angular/router';
import { take } from 'rxjs';
import { inject } from '@angular/core';
import { UserService } from '../../dashboard/services/user/user.service';
import { UserModel } from '../models/user/user-model';

export const userDataResolverResolver: ResolveFn<UserModel | null> = (
  _route,
) => {
  const userService = inject(UserService);
  return userService.loadUserData().pipe(take(1));
};
